import { useEffect, useRef, type ReactNode } from "react";
import { usePageTracking } from "./use-page-tracking";
import { useAnalytics } from "./use-analytics";
import type { AnalyticsUser } from "./types";

interface AnalyticsProviderProps {
  children: ReactNode;
  user?: AnalyticsUser | null;
}

export function AnalyticsProvider({ children, user }: AnalyticsProviderProps) {
  usePageTracking();

  const { identify, reset } = useAnalytics();
  const prevUserId = useRef<string | null>(null);

  useEffect(() => {
    if (user && user.id !== prevUserId.current) {
      identify(user);
      prevUserId.current = user.id;
    } else if (!user && prevUserId.current) {
      reset();
      prevUserId.current = null;
    }
  }, [user, identify, reset]);

  return <>{children}</>;
}
